export default __webpack_public_path__ + "static/media/phone.f461d141.svg";